import AcceptIcon from './component'

export default AcceptIcon
